module.exports = __webpack_public_path__ + "static/media/call.ccd9b4e0.svg";